import { CALL_API } from 'redux-api-middleware'

import getAccessToken from '../../../lib/utils/getAccessToken'

import { BASE_URL } from '../../../constants'

import { GET_REPORT, FILTER, SORT, MODULE, GET_EXPORT, MORE_FILTER } from './constants'
import { getFilter } from './selectors'

/**
 * @param {number} month
 * @param {number} year
 * @param {string} project_code
 * @param {string} lob
 */
export const fetchReport = (month, year, project = '', lob = '') => {
  const filter_month = `month=${month}`
  const filter_year = `year=${year}`
  const project_code = project ? `project_code=${project}` : ''
  const lob_id = lob ? `lob_id=${lob}` : ''
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/timesheet-report/summary-report?${filter_month}&${filter_year}&${project_code}&${lob_id}`,
      method: 'GET',
      types: [GET_REPORT.REQUEST, GET_REPORT.SUCCESS, GET_REPORT.FAILURE],
      headers: {
        authorization: `bearer ${getAccessToken()}`,
      },
    },
  }
}

/**
 * @param {number} month
 * @param {number} year
 * @param {string} project_code
 * @param {string} lob
 */
export const exportExcel = (month, year, project = '', lob = '') => {
  const filter_month = `month=${month}`
  const filter_year = `year=${year}`
  const project_code = project ? `project_code=${project}` : ''
  const lob_id = lob ? `lob_id=${lob}` : ''
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/timesheet-report/summary-export?${filter_month}&${filter_year}&${project_code}&${lob_id}`,
      method: 'GET',
      types: [GET_EXPORT.REQUEST, GET_EXPORT.SUCCESS, GET_EXPORT.FAILURE],
      headers: {
        authorization: `bearer ${getAccessToken()}`,
      },
    },
  }
}

/**
 * Reset module's state
 */
export const resetExportExcel = () => ({
  type: GET_EXPORT.RESET
})

/**
 * Reset module's state
 */
export const resetModule = () => ({
  type: MODULE.RESET,
})

/**
 * @param {string} target
 * @param {string | null} value
 */
export const setFilter = (target, value) => async (dispatch, getState) => {
  // updating filter value
  dispatch({ type: FILTER.SET_FIELD, payload: [target, value] })
  // const filter = getFilter(getState())
  // await dispatch(fetchReport(filter.month, filter.year, filter.project, filter.lob))
}

/**
 * @param {string} target
 * @param {string | null} value
 */
export const setMoreFilter = (target, value) => ({
  type: MORE_FILTER.SET_FIELD,
  payload: [target, value],
})

/**
 * @param {string} target
 * @param {string | null} value
 */
export const setSort = (target, value) => ({
  type: SORT.SET_FIELD,
  payload: [target, value],
})



// WEBPACK FOOTER //
// ./src/pages/report/summary-timesheet/actions.js